/* tslint:disable */
/* eslint-disable */
/**
 * Private UI API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: ${project.version}
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    FirmwareType,
    FirmwareTypeFromJSON,
    FirmwareTypeFromJSONTyped,
    FirmwareTypeToJSON,
} from './FirmwareType';

/**
 * 
 * @export
 * @interface FirmwareByDeviceTypeResponse
 */
export interface FirmwareByDeviceTypeResponse {
    /**
     * 
     * @type {string}
     * @memberof FirmwareByDeviceTypeResponse
     */
    packageName?: string;
    /**
     * 
     * @type {FirmwareType}
     * @memberof FirmwareByDeviceTypeResponse
     */
    type?: FirmwareType;
    /**
     * 
     * @type {string}
     * @memberof FirmwareByDeviceTypeResponse
     */
    version?: string;
}

export function FirmwareByDeviceTypeResponseFromJSON(json: any): FirmwareByDeviceTypeResponse {
    return FirmwareByDeviceTypeResponseFromJSONTyped(json, false);
}

export function FirmwareByDeviceTypeResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): FirmwareByDeviceTypeResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'packageName': !exists(json, 'packageName') ? undefined : json['packageName'],
        'type': !exists(json, 'type') ? undefined : FirmwareTypeFromJSON(json['type']),
        'version': !exists(json, 'version') ? undefined : json['version'],
    };
}

export function FirmwareByDeviceTypeResponseToJSON(value?: FirmwareByDeviceTypeResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'packageName': value.packageName,
        'type': FirmwareTypeToJSON(value.type),
        'version': value.version,
    };
}

